import { createTheme, ThemeOptions } from '@mui/material/styles'
import { enUS, Localization } from '@mui/material/locale'

import breakpoints from './breakpoints'
import componentsOverride from './overrides'
import palette from './palette'
import shadows from './shadows'
import typography from './typography'
import GlobalStyles from './globalStyles'

/**
 * Types
 */

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    neutral: string
    dark: string
  }
  interface SimplePaletteColorOptions {
    lighter: string
    darker: string
  }
  interface PaletteColor {
    lighter: string
    darker: string
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    soft: true
  }
}

declare module '@mui/material/ButtonGroup' {
  interface ButtonGroupPropsVariantOverrides {
    soft: true
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    soft: true
  }
}

declare module '@mui/material/Pagination' {
  interface PaginationPropsColorOverrides {
    info: true
    success: true
    warning: true
    error: true
  }
}

/**
 * Provider
 */

export function getTheme(locale: Localization = enUS, mode: 'light' | 'dark' = 'light') {
  const isLight = mode === 'light'
  const themeOptions: ThemeOptions = {
    palette: isLight ? palette.light : palette.dark,
    typography,
    breakpoints,
    shape: { borderRadius: 8 },
    direction: 'ltr',
    shadows: isLight ? shadows.light : shadows.dark,
  }

  const theme = createTheme(themeOptions, locale)

  theme.components = componentsOverride(theme)
  return theme
}

export { GlobalStyles }
